import CheckboxFilledIcon from './CheckboxFilledIcon';

const CheckboxCheckedIcon = () => {
  return (
    <CheckboxFilledIcon>
      <path d="M8.5 11L6.5 9L5 10.5L8.5 14L15 7.5L13.5 6L8.5 11Z" />
    </CheckboxFilledIcon>
  );
};

export default CheckboxCheckedIcon;
